/**
 * Determines the API URL based on the current domain
 * @param domain - The current domain (window.location.host)
 * @returns The appropriate API URL
 * @throws Error if required environment variables are missing
 */
export const getApiUrlFromDomain = (
  domain: string
): string => {
  // Check if domain is localhost or 127.0.0.1
  if (
    domain.includes("localhost") ||
    domain.includes("127.0.0.1")
  ) {
    const apiUrl = import.meta.env.VITE_DEVELOP_API_URL

    if (!apiUrl) {
      const error = new Error(
        "VITE_DEVELOP_API_URL is not configured. Please set this environment variable for localhost development."
      )
      console.error(error.message)
      throw error
    }

    return apiUrl
  }

  // For all other domains, use the host API URL
  const apiUrl = import.meta.env.VITE_HOST_API_URL

  if (!apiUrl) {
    const error = new Error(
      "VITE_HOST_API_URL is not configured. Please set this environment variable for production/staging environments."
    )
    console.error(error.message)
    throw error
  }

  return apiUrl
}
